import styled from 'styled-components';

export const SVG = styled.svg`
    max-height: 100%;
    max-width: 100%;
`;

export const Circle = styled.circle(({theme}) => ({
    fill: theme.svg?.authors?.backgroundColor
}));

export const Silhouette = styled.path(({theme}) => ({
    fill: theme.svg?.authors?.foregroundColor
}));
